<template lang="pug">
  //- img.main-content(src=`${pathImg}main.png`, alt="")
  .main-content.container
      .main-content__title
          span(v-html="tr.main__content.title")

      .main-content__section.main-content__section_flex
          .main-content__beffore
              .main-content__befforeTitle.main-content__mobile-title
                  div(v-html="tr.main__content.befforeTitle")
                  div.main-content__lstDsc.main-content__dsc.main-content__subtitle_margin_0(v-html="tr.main__content.befforeDsc")
              .main-content__border
              picture
                  //- source(media="(max-width: 480px)" srcset=`#`)
                  img.main-content__wrap.img_1.wow.fadeIn(src=`../../../assets/images/main-content/img_1.jpg`, alt="", data-wow-duration="2s")

          .main-content__wrap
              picture
                  //- source(media="(max-width: 1024px)" srcset=`${pathImg}main-content/ipad/img_2.jpg`)
                  //- source(media="(max-width: 480px)" srcset=`${pathImg}img-mobile_2.jpg`)
                  img.main-content__img.img_2.wow.castomFadeIn(src=`../../../assets/images/main-content/img_2.png`, alt="", data-wow-duration="1s")
              .main-content__border
              .main-content__subtitle.main-content__subtitle_1.wow.fadeIn(data-wow-duration="2s")
                  span(v-html="tr.main__content.subtitle")
              .main-content__dsc.main-content__dsc_1.wow.fadeIn(data-wow-duration="2s")
                  span(v-html="tr.main__content.dsc")
              picture.mobile-hide
                  //- source(media="(max-width: 480px)" srcset=`${pathImg}main-content_mobile_1.jpg`)
                  //- img.main-content__mobile_1(src=`${pathImg}main-content/ipad/img_1.jpg`, alt="")
                  img.main-content__mobile_1(src=`../../../assets/images/main-content/img_1.jpg`, alt="")
              //- .main-content__mobile-title.main-content__phoneTitle(v-html="tr.main__content.subtitle")
              .main-content__border

              .main-content__phone
                  img.main-content__phoneImg.img_3.wow.bounceInUp(src=`../../../assets/images/main-content/img_3.png`, alt="" v-if="!englishVersion && !mexicoVersion")
                  img.main-content__phoneImg.img_3.wow.bounceInUp(src=`../../../assets/images/main-content/img_3_en.png`, alt="" v-if="englishVersion || mexicoVersion")
                  .main-content__border
                  .main-content__phoneWrap
                      img.main-content__phoneIcon.wow.fadeIn(src=`../../../assets/images/logo_icon.png`, alt="", data-wow-duration="2s")
                      .main-content__phoneTitle.wow.fadeIn(data-wow-duration="2s")
                          span(v-html="tr.main__content.phoneTitle")
                          div.main-content__lstDsc.main-content__dsc.main-content__subtitle_margin_0(v-html="tr.main__content.phoneDsc")
              .main-content__border

      .main-content__section.main-content__section_flex
          picture
              //- source(media="(max-width: 480px)" srcset=`#`)
              img.main-content__wrap.img_4.wow.FadeIn(src=`../../../assets/images/main-content/img_4.png`, alt="", data-wow-duration="1s")
          .main-content__wrap
              picture
                  //- source(media="(max-width: 1024px)" srcset=`${pathImg}main-content/ipad/img_5.jpg`, data-wow-duration="1s" )
                  //- source(media="(max-width: 1024px)" srcset=`${pathImg}main-content/img_5.jpg`, data-wow-duration="1s" )
                  //- source(media="(max-width: 480px)" srcset=`${pathImg}img-mobile_5.jpg`)
                  img.main-content__img.img_5.wow.castomFadeIn(src=`../../../assets/images/main-content/img_5.jpg`, alt="")
              .main-content__border
              .main-content__subtitle.main-content__subtitle_margin_100
                  span(v-html="tr.main__content.subtitle_2")
              .main-content__dsc.main-content__dsc_margin_100
                  span(v-html="tr.main__content.dsc_2")

              .main-content__phone
                  img.main-content__phoneImg.img_6.wow.castomFadeIn(v-if="lang_switips === 'ru'" src=`../../../assets/images/img_6_ru.png`, alt="")
                  img.main-content__phoneImg.img_6.wow.castomFadeIn(v-if="lang_switips === 'en'" src=`../../../assets/images/img_6_en.png`, alt="")
                  img.main-content__phoneImg.img_6.wow.castomFadeIn(v-if="lang_switips === 'kz'" src=`../../../assets/images/img_6_kz.png`, alt="")
                  img.main-content__phoneImg.img_6.wow.castomFadeIn(v-if="lang_switips === 'ua'" src=`../../../assets/images/img_6_ua.png`, alt="")

      .main-content__section.main-content__section_mobile-flex
          .main-content__border
          .main-content__subtitle.main-content__subtitle_m_50
              span(v-html="tr.main__content.subtitle_3")
              div.main-content__lstDsc.main-content__dsc.main-content__subtitle_margin_0(v-html="tr.main__content.subtitle_4_Desc")
          .main-content__border.main-content_o_2
          .main-content__border
          picture
              //- source(media="(max-width: 1024px)" srcset=`${pathImg}main-content/ipad/img_7.jpg`)
              //- source(media="(max-width: 1024px)" srcset=`${pathImg}main-content/img_7.jpg`)
              //- source(media="(max-width: 480px)" srcset=`${pathImg}img-mobile_7.jpg`)
              img.img_7.wow.castomFadeIn(src=`../../../assets/images/main-content/img_7.jpg`, alt="", data-wow-duration="1s")
          .main-content__wrap_flex.main-content_o_3
              .main-content__mobile-title.main-content__subtitle.main-content__subtitle_m_150
                  span(v-html="tr.main__content.subtitle_5")
                  div.main-content__lstDsc.main-content__dsc.main-content__subtitle_margin_0(v-html="tr.main__content.subtitle_5_Desc")
              .main-content__border
              picture
                  //- source(media="(max-width: 1024px)" srcset=`${pathImg}main-content/ipad/img_8.jpg`)
                  //- source(media="(max-width: 1024px)" srcset=`${pathImg}main-content/img_8.jpg`)
                  //- source(media="(max-width: 1024px)" srcset=`${pathImg}img-mobile_8.jpg`)
                  img.main-content__wrap.img_8.wow.castomFadeIn(src=`../../../assets/images/main-content/img_8.png`, alt="", data-wow-duration="1s")
              img.main-content__phoneImg.img_9.wow.castomFadeIn(src=`../../../assets/images/main-content/img_9.jpg`, alt="", data-wow-duration="1s")
          .main-content__lst
              .main-content__border
              .main-content__lstTitle
                  span(v-html="tr.main__content.lstTitle")
              .main-content__lstDsc
                  span(v-html="tr.main__content.lstDsc")
      .main-content__border_dsc
</template>

<script>
import langOps from '@/mixins/langOps'
export default {
  data () {
    return {
      section: 'main'
    }
  },
  mixin: [langOps]
}
</script>

<style lang="scss">
@import './style.scss';
</style>
